import { useRef, useCallback } from 'react'
import styles from './ChartTooltip.module.css'

export type TooltipVariant = 'dark' | 'light' | 'glass' | 'accent'

export function useChartTooltip(variant: TooltipVariant = 'dark') {
  const tooltipRef = useRef<HTMLDivElement>(null)

  const show = useCallback((x: number, y: number, text: string) => {
    const el = tooltipRef.current
    if (!el) return

    el.replaceChildren()
    const lines = text.split('\n')
    lines.forEach((line, i) => {
      const colonIdx = line.indexOf(':')
      if (i > 0 && colonIdx > -1) {
        const row = document.createElement('div')
        row.className = styles.row
        const labelSpan = document.createElement('span')
        labelSpan.textContent = line.slice(0, colonIdx)
        const valueSpan = document.createElement('span')
        valueSpan.className = styles.value
        valueSpan.textContent = line.slice(colonIdx + 1).trim()
        row.append(labelSpan, valueSpan)
        el.appendChild(row)
      } else {
        const header = document.createElement('div')
        header.className = styles.header
        header.textContent = line
        el.appendChild(header)
      }
    })

    el.style.left = `${x}px`
    el.style.top = `${y}px`
    el.style.opacity = '1'
  }, [])

  const hide = useCallback(() => {
    const el = tooltipRef.current
    if (!el) return
    el.style.opacity = '0'
  }, [])

  const tooltipClassName = `${styles.base} ${styles[variant]}`

  return { tooltipRef, show, hide, tooltipClassName }
}
